import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
`;

export const Item = styled.div`
  width: 49.5%;
  float: left;
  margin-right: 0.25%;
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;
